import { render, staticRenderFns } from "./CreateUniversity.vue?vue&type=template&id=0939b503&"
import script from "./CreateUniversity.vue?vue&type=script&lang=js&"
export * from "./CreateUniversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports